"use strict";

/**
 * @description Initializes the checkboxes validation functionality
 */

function checkboxesValidation() {
    const checkboxes = Array.from(document.querySelectorAll(".js-sport-preference"));
    const invalidFeedback = document.getElementById("form-sport-preferences-error");
    const sportPreference = document.querySelector(".js-sport-preference");

    function isChecked(checkbox) {
        return checkbox.checked;
    }

    if (sportPreference) {
        const errorMessage = sportPreference.getAttribute("data-missing-error");
        var error = false;

        if (!checkboxes.some(isChecked)) {
            invalidFeedback.innerHTML = errorMessage;
            invalidFeedback.classList.add("visible");
            error = true;
        }

        return error;
    }
}

module.exports = checkboxesValidation;
